import { EventEmitter } from "events";
import * as event from "./ClockEvent";
class Clock extends EventEmitter {
  /**
   * やること
   * 締め切り時間を設定
   * もはや締め切り時間を過ぎている
   *
   * 過ぎてないなら待つ。
   * イベント "deadline"を発火。
   */
  constructor() {
    super();
    this.passed = false;
  }

  /**
   *
   * @param closingAt
   */
  setup(closingAt) {
    this.closingAt = closingAt;
    this.updateTimer();
  }

  updateTimer() {
    if (this.timerId)
    {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
    this.timerId = setTimeout(() => {
      this.update();
    }, 1000);
  }
  update() {
    if (this.passed)
      return;
    if (this.closingAt < new Date()) {
      console.log("[Clock] 締め切りきました");
      this.emit(event.PASSED_DEADLINE);
      this.passed = true;
    }
    this.updateTimer();
  }
}

export const clock = new Clock();
